import styled, { css } from 'styled-components';

export default styled.div`
  ${({ theme }) => css`
    background-color: rgb(4, 51, 59, 0.7);
    backdrop-filter: blur(1px);
    z-index: 12;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    overflow: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    /* border: 10px solid ${theme?.colour?.secondary ?? '#04333B'};
    border-radius: 20px; */

    @media only screen and (min-width: 768px) {
      border: unset;
      border-radius: unset;
    }
  `}
`;